import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// Envoie un magic link par e-mail. Le même flux sert à se connecter ET à créer le compte.
export async function sendMagicLink(email) {
  const { error } = await supabase.auth.signInWithOtp({
    email: email.trim(),
    options: { emailRedirectTo: window.location.origin },
  });
  if (error) throw error;
}

export async function signOut() {
  await supabase.auth.signOut({ scope: "local" });
}

// Connexion secondaire par mot de passe (le magic link reste la méthode principale).
export async function signInWithPassword(email, password) {
  const { error } = await supabase.auth.signInWithPassword({
    email: email.trim(),
    password,
  });
  if (error) throw error;
}

// Bypass temporaire : connexion auto sur un compte fixe (eric@0gbaltics.com),
// tant que le SMTP/magic link n'est pas configuré. À retirer plus tard.
export const BYPASS_AUTH = process.env.REACT_APP_BYPASS_AUTH === "true";

export async function ensureBypassSession() {
  const { data } = await supabase.auth.getSession();
  if (data.session) return data.session;
  const { data: signIn, error } = await supabase.auth.signInWithPassword({
    email: process.env.REACT_APP_BYPASS_EMAIL,
    password: process.env.REACT_APP_BYPASS_PASSWORD,
  });
  if (error) throw error;
  return signIn.session;
}

